import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
const forYou = ['tu barriga cambia en el día', 'la ropa te aprieta al final de la tarde', 'quieres alivio y orden, no perfección', 'quieres un plan con comida real y reglas claras'];
const notForYou = ['quieres promesas imposibles tipo "10 kilos en una semana"', 'tienes síntomas severos que requieren atención médica (aquí la prioridad es salud profesional)'];
export function ParaQuienSection() {
  return <section className="w-full bg-[#1B4332] py-20 md:py-28 px-4" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <motion.div {...fadeInUp} className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#FAF3E0] mb-6" data-id="element-107">
            ¿Es para ti?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-108">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#A7C4A0]/20 rounded-3xl p-8" data-id="element-109">
            <h3 className="text-xl font-bold text-[#A7C4A0] mb-6" data-id="element-110">
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-111">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-112">
                  <div className="w-6 h-6 rounded-full bg-[#A7C4A0] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-113">
                    <CheckIcon className="w-4 h-4 text-[#1B4332]" data-id="element-114" />
                  </div>
                  <span className="text-[#FAF3E0]/90" data-id="element-115">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-[#C75B39]/20 rounded-3xl p-8" data-id="element-116">
            <h3 className="text-xl font-bold text-[#C75B39] mb-6" data-id="element-117">
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-118">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-119">
                  <div className="w-6 h-6 rounded-full bg-[#C75B39] flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-120">
                    <XIcon className="w-4 h-4 text-white" data-id="element-121" />
                  </div>
                  <span className="text-[#FAF3E0]/90" data-id="element-122">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}